var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : "" + key, ref: null, props: props, _owner: null }; }

import React from 'react';
import PropTypes from 'prop-types';
import { useStyles } from "./InfoStyles";
import DoneIcon from '@material-ui/icons/Done';
import QueryBuilderIcon from '@material-ui/icons/QueryBuilder';
import ErrorIcon from '@material-ui/icons/Error';
import { formatTime } from "../../../../helpers/dateManagement";

var _ref2 = /*#__PURE__*/_jsx(DoneIcon, {});

var _ref3 = /*#__PURE__*/_jsx(QueryBuilderIcon, {});

var _ref4 = /*#__PURE__*/_jsx(ErrorIcon, {});

const Info = _ref => {
  let message = _ref.message,
      styleProps = _ref.styleProps,
      messageIsFromUser = _ref.messageIsFromUser;
  const classes = useStyles(styleProps);
  return _jsx("div", {
    id: "".concat(message.id, "Info"),
    className: classes.container
  }, void 0, formatTime(new Date(message.date)), messageIsFromUser && React.createElement(React.Fragment, null, message.status === 'sent' && _ref2, message.status === 'pending' && _ref3, message.status === 'failed' && _ref4));
};

export { Info };